import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-item"
};
const _hoisted_2 = {
  class: "sidenav-mini-icon"
};
const _hoisted_3 = {
  class: "sidenav-normal"
};
import { useLayoutStore } from '@/store/modules/layout';
export default {
  __name: 'SidenavItem',
  props: {
    to: {
      type: [Object, String],
      required: true
    },
    miniIcon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const layoutStore = useLayoutStore();
    const props = __props;
    const beforePathInit = () => {
      layoutStore.setBeforePath();
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("li", _hoisted_1, [_createVNode(_component_router_link, {
        class: _normalizeClass(["nav-link", __props.isActive ? 'active' : '']),
        to: __props.to,
        onClick: beforePathInit
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.miniIcon), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(__props.text), 1)]),
        _: 1
      }, 8, ["to", "class"])]);
    };
  }
};